import React, {useContext, useState, useCallback, useEffect, useMemo} from 'react'

import _ from 'lodash'
import useGetCalendarViewsReducer from '../../state/calendar-views/get-calendar-views/reducer'
import useGetShareableCalendarViewsReducer from '../../state/calendar-views/get-shareable-views/reducer'
import useGetGroupsReducer from '../../state/groups/get-groups/reducer'
import {getCalendarViews} from '../../state/calendar-views/get-calendar-views/actions'
import {getShareableCalendarViews} from '../../state/calendar-views/get-shareable-views/actions'
import {getGroups} from '../../state/groups/get-groups/actions'
import {
  createCalendarView,
  updateCalendarView,
} from '../../state/calendar-views/post-calendar-view/actions'
import usePostCalendarViewReducer from '../../state/calendar-views/post-calendar-view/reducer'

import {getDisplayFields} from '../../state/calendar-views/get-display-fields/actions'
import useGetDisplayFieldReducer from '../../state/calendar-views/get-display-fields/reducer'

// configuration
import useGetConfigurationReducer from '../../state/reservation/get-configuration/reducer'
import {getConfiguration} from '../../state/reservation/get-configuration/actions'

import {getEntity} from '../../state/entities/get-entity/actions'
import {useEntityReducer} from '../../state/entities/get-entity/reducer'

// // items
import {getReservationEntityItems} from '../../state/entities/get-reservation-entity-items/actions'
import useGetReservationEntityItemsReducer, {
  ActionTypes as getReservationEntityItemsActionTypes,
} from '../../state/entities/get-reservation-entity-items/reducer'

import {getFilterFieldValues} from '../../state/reservation/filter-field-values/actions'
import usefilterFieldValuesReducer from '../../state/reservation/filter-field-values/reducer'

const CalendarViewContext = React.createContext(null)

function CalendarViewContextProvider(props) {
  // [A]
  const [views, viewsDispatch] = useGetCalendarViewsReducer()
  const [shareableViews, shareableViewsDispatch] = useGetShareableCalendarViewsReducer()
  const [displayFields, displayFieldsDispatch] = useGetDisplayFieldReducer()

  const [saveGroupViewState, saveGroupViewDispatch] = usePostCalendarViewReducer()

  const [groups, groupsDispatch] = useGetGroupsReducer()
  const [viewData, setViewData] = useState({
    selectedView: {},
    selectedFilteredViews: [],
    selectedFilterValueFields: [],
  })
  // for shareable calendar views
  const [shareableViewData, setShareableViewData] = useState({
    selectedView: {},
    selectedFilteredViews: [],
    selectedFilterValueFields: [],
    is_shareable_view: '',
  })

  const [sharableConfiguration, configurationDispatch] = useGetConfigurationReducer()

  // fields
  const [sharableEntity, entityDispatch] = useEntityReducer()

  // items
  const [sharableEntityObjects, entityObjectsDispatch] = useGetReservationEntityItemsReducer()
  const [sharableCheckObjects, checkObjectsDispatch] = useGetReservationEntityItemsReducer()

  const [sharableFilters, setSharableFilters] = useState([])
  const [sharableFilterFieldValues, filterFieldValuesDispatch] = usefilterFieldValuesReducer()
  const [currentView, setCurrentView] = useState('')

  const sharableEntityFields = useMemo(() => {
    const field = sharableEntity?.entities?.entities_details
    if (!_.isEmpty(field)) {
      if (!_.isEmpty(field[0].fields)) {
        let data = field[0].fields
        return data
      }
      return []
    }
  }, [sharableEntity])

  // get configuration data
  const loadSharableConfiguration = useCallback(
    group_id => {
      getConfiguration(configurationDispatch, {group_id})
      getEntity(group_id, entityDispatch)
    },
    [configurationDispatch, entityDispatch]
  )

  const loadSharableEntityObjects = useCallback(
    (group_id, params = {}) => {
      getReservationEntityItems(entityObjectsDispatch, group_id, params)
    },
    [entityObjectsDispatch]
  )

  const checkSharableEntityObjects = useCallback(
    (group_id, params = {}) => {
      getReservationEntityItems(checkObjectsDispatch, group_id, params)
    },
    [checkObjectsDispatch]
  )

  // get reserved for data
  const loadSharableFilterFieldValues = useCallback(
    (field_id, search, params) => {
      getFilterFieldValues(filterFieldValuesDispatch, field_id, search, params)
    },
    [filterFieldValuesDispatch]
  )

  // [B]
  const loadCalendarViews = useCallback(() => {
    getCalendarViews(viewsDispatch, localStorage.user_id)
  }, [viewsDispatch])

  // get shareable view
  const loadShareableCalendarViews = useCallback(() => {
    getShareableCalendarViews(shareableViewsDispatch, localStorage.user_id)
  }, [shareableViewsDispatch])

  // get shareable view
  const loadDisplayFields = useCallback(
    (group_id, params = {}) => {
      getDisplayFields(displayFieldsDispatch, group_id, params)
    },
    [displayFieldsDispatch]
  )

  // useMemo so we can return a promise
  const saveGroupView = useMemo(
    () => groupView => {
      const _confirmFunc = !groupView.id ? createCalendarView : updateCalendarView
      return _confirmFunc(saveGroupViewDispatch, {
        user_id: localStorage.user_id,
        ..._.omit(groupView, ['calendar_child_view']),
      })
    },
    [saveGroupViewDispatch]
  )

  // Effects
  useEffect(() => {
    let _cache = localStorage.getItem('_calendar_vw')
    getCalendarViews(viewsDispatch, localStorage.user_id).then(res => {
      if (_cache) {
        try {
          _cache = JSON.parse(_cache)
          const _sel = res.data.find(f => f.group_view.entity_id === _cache.entity_id)
          if (_sel) {
            const _selFiltered = []
            if (_cache.filt_view_ids.length > 0) {
              _cache.filt_view_ids.map(id => {
                const sel_data = (_sel.group_view.calendar_child_view || []).find(
                  f => f?._id['$oid'] === id
                )
                if (sel_data) {
                  _selFiltered.push(sel_data)
                }
                return _selFiltered
              })
            }
            if (_selFiltered) {
              setViewData(data => {
                data.selectedView = _sel
                data.selectedFilteredViews = _selFiltered
                return {...data}
              })
              // shareable view
              // setShareableViewData(data => {
              //   data.selectedView = _sel
              //   data.selectedFilteredViews.push(_selFiltered)
              //   return {...data}
              // })
            } else {
              setViewData(data => {
                data.selectedView = _sel
                return {...data}
              })
              // shareable view
              // setShareableViewData(data => {
              //   data.selectedView = _sel
              //   return {...data}
              // })
            }
          }
        } catch (err) {
          console.log("_calendar_vw can't be loaded", err)
        }
      }
    })
    getGroups(groupsDispatch)

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    localStorage.setItem(
      '_calendar_vw',
      JSON.stringify({
        entity_id: viewData?.selectedView?.group_view?.entity_id || null,
        filt_view_ids:
          viewData?.selectedFilteredViews?.map(v => {
            return v._id['$oid']
          }) || [],
      })
    )
  }, [viewData])

  //for shareable view
  useEffect(() => {
    localStorage.setItem(
      '_calendar_svw',
      JSON.stringify({
        entity_id: shareableViewData?.selectedView?.group_view?.entity_id || null,
        filt_view_ids:
          shareableViewData.length >
            0?.selectedFilteredViews?.map(v => {
              return v._id['$oid']
            }) || null,
      })
    )
  }, [shareableViewData])

  // update view data
  useEffect(() => {
    setViewData(p => {
      if (!p) return p

      const entity_id = p.selectedView?.group_view?.entity_id
      const filt_view_ids = p.selectedFilteredViews?.map(v => {
        return v._id['$oid']
      })
      const _sel = views.data.find(f => f.group_view.entity_id === entity_id)
      if (_sel) {
        const _selFiltered = []
        if (filt_view_ids.length > 0) {
          filt_view_ids.map(id => {
            const sel_data = (_sel.group_view.calendar_child_view || []).find(
              f => f?._id['$oid'] === id
            )
            sel_data && _selFiltered.push(sel_data)
            return _selFiltered
          })
        }
        if (_selFiltered) {
          return {selectedView: _sel, selectedFilteredViews: _selFiltered}
        } else {
          return {...p, selectedView: _sel}
        }
      }
      return p
    })
  }, [views, setViewData])

  // update shareable data
  useEffect(() => {
    setShareableViewData(p => {
      if (!p) return p

      const entity_id = p.selectedView?.group_view?.entity_id
      const filt_view_ids = p.selectedFilteredViews?.map(v => {
        return v._id['$oid']
      })

      const _sel = views.data.find(f => f.group_view.entity_id === entity_id)
      if (_sel) {
        const _selFiltered = (_sel.group_view.calendar_child_view || []).find(
          f => f?._id['$oid'] === filt_view_ids
        )
        if (_selFiltered) {
          return {selectedView: _sel, selectedFilteredViews: _selFiltered}
        } else {
          return {...p, selectedView: _sel}
        }
      }
      return p
    })
  }, [views, setShareableViewData])

  const selectedViewGroup = useMemo(() => {
    if (viewData.selectedView?.group_view) {
      return groups.data.find(d => d.id === viewData.selectedView.group_view.entity_id) || null
    }
    return null
  }, [groups, viewData])

  // shareable view
  const selectedShareableViewGroup = useMemo(() => {
    if (shareableViewData.selectedView?.group_view) {
      return (
        groups.data.find(d => d.id === shareableViewData.selectedView.group_view.entity_id) || null
      )
    }
    return null
  }, [groups, shareableViewData])

  const value = {
    views,
    groups,
    loadCalendarViews,
    shareableViews,
    loadShareableCalendarViews,
    saveGroupView,
    viewData,
    setViewData,
    saveGroupViewState,
    selectedViewGroup,
    displayFields,
    loadDisplayFields,
    loadSharableConfiguration,
    sharableConfiguration,
    sharableEntity,
    sharableEntityFields: sharableEntityFields,
    sharableEntityObjects,
    sharableCheckObjects,
    loadSharableEntityObjects,
    checkSharableEntityObjects,
    sharableFilters,
    setSharableFilters,
    sharableFilterFieldValues,
    loadSharableFilterFieldValues,
    shareableViewData,
    setShareableViewData,
    currentView,
    setCurrentView,
  }

  // [C]
  return <CalendarViewContext.Provider value={value}>{props.children}</CalendarViewContext.Provider>
}

const CalendarViewContextConsumer = CalendarViewContext.Consumer

const useCalendarViewContext = () => {
  return useContext(CalendarViewContext)
}
export default useCalendarViewContext
export {CalendarViewContext, CalendarViewContextProvider, CalendarViewContextConsumer}
